import { EditCandidateProfileProvider } from './edit-candidate-profile.provider';
import { FeatureEditCandidateProfileView } from './edit-candidate-profile';

export const FeatureEditCandidateProfile = () => {
   return (
      <EditCandidateProfileProvider>
         <FeatureEditCandidateProfileView />
      </EditCandidateProfileProvider>
   );
};
